// Batch 25 · B3 (M19) — save the file a finished job holds (GET /jobs/{id}/file) in the browser.
import { API_URL } from "@/lib/api";

export async function downloadJobFile(jobId, fallbackName) {
  const tok = localStorage.getItem("af_token") || localStorage.getItem("token");
  const res = await fetch(`${API_URL}/jobs/${jobId}/file`, { headers: { Authorization: `Bearer ${tok}` } });
  if (!res.ok) throw new Error(`download ${res.status}`);
  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") || "";
  const m = cd.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
  const name = m ? decodeURIComponent(m[1] || m[2]) : fallbackName;
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name || fallbackName || `${jobId}.bin`;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(a.href);
  return name;
}
